import React from "react";

const RegisteredTags = ({
    tags,
    totalCount,
    loading,
    error,
    query,
    onQueryChange,
    serverFilter,
    onServerFilterChange,
    servers,
    serverNameById,
    statusById,
    selectedId,
    onEdit,
}) => (
    <section className="tag-page__card tag-page__registry" aria-labelledby="registered-tags-heading">
        <div className="tag-page__card-head">
            <h2 id="registered-tags-heading">Registered tags</h2>
            <p>
                {loading
                    ? "Loading stored tags…"
                    : `${tags.length} of ${totalCount} shown. Search by name or Node ID.`}
            </p>
        </div>
        <div className="tag-page__registry-tools">
            <div className="tag-page__field">
                <label htmlFor="tag-search">Search</label>
                <input
                    id="tag-search"
                    type="search"
                    value={query}
                    onChange={(event) => onQueryChange(event.target.value)}
                    placeholder="Name or Node ID"
                />
            </div>
            <div className="tag-page__field">
                <label htmlFor="tag-server-filter">OPC Server</label>
                <select
                    id="tag-server-filter"
                    value={serverFilter}
                    onChange={(event) => onServerFilterChange(event.target.value)}
                >
                    <option value="all">All servers</option>
                    {servers.map((server) => (
                        <option key={server.id} value={String(server.id)}>
                            {server.name}
                        </option>
                    ))}
                </select>
            </div>
        </div>
        {error ? <p className="tag-page__banner is-error" role="alert">{error}</p> : null}
        {loading ? (
            <p className="tag-page__empty">Loading tags and servers…</p>
        ) : tags.length === 0 ? (
            <p className="tag-page__empty">
                {totalCount === 0 ? "No tags are stored yet." : "No tags match this search."}
            </p>
        ) : (
            <div className="tag-page__registry-scroll">
                <table className="tag-page__registry-table">
                    <thead>
                        <tr>
                            <th scope="col">Connection</th>
                            <th scope="col">Lifecycle</th>
                            <th scope="col">Tag name</th>
                            <th scope="col">Tag type</th>
                            <th scope="col">Signal</th>
                            <th scope="col">OPC data type</th>
                            <th scope="col">Access</th>
                            <th scope="col">Group</th>
                            <th scope="col">Node ID</th>
                            <th scope="col">OPC Server</th>
                            <th scope="col"><span className="tag-page__sr">Edit</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        {tags.map((tag) => {
                            const status = statusById[tag.id] || "UNKNOWN";
                            const serverName = serverNameById[String(tag.server)];
                            const lifecycle = tag.is_active === false ? "ARCHIVED" : tag.is_active === true ? "ACTIVE" : "—";
                            const kind = tag.is_calculated === true ? "CALCULATED" : tag.is_calculated === false ? "PHYSICAL" : "—";
                            return (
                                <tr key={tag.id} className={tag.id === selectedId ? "is-selected" : undefined}>
                                    <td data-label="Connection">
                                        <span className={`tag-page__status tag-page__status--${status}`}>{status}</span>
                                    </td>
                                    <td data-label="Lifecycle">
                                        <span className={`tag-page__lifecycle tag-page__lifecycle--${lifecycle}`}>{lifecycle}</span>
                                    </td>
                                    <td data-label="Tag name"><span className="tag-page__strong">{tag.name}</span></td>
                                    <td data-label="Tag type">{kind}</td>
                                    <td data-label="Signal">{tag.signal_type || "—"}</td>
                                    <td data-label="OPC data type" className="tag-page__mono">{tag.opc_data_type || "—"}</td>
                                    <td data-label="Access">{tag.access_mode || "—"}</td>
                                    <td data-label="Group">{tag.group_name || (tag.group ? tag.group : "No group")}</td>
                                    <td data-label="Node ID" className="tag-page__mono">{tag.node_id}</td>
                                    <td data-label="OPC Server">{serverName || tag.server}</td>
                                    <td data-label="Edit">
                                        <button type="button" className="tag-page__button" onClick={() => onEdit(tag.id)}>
                                            Edit
                                        </button>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        )}
    </section>
);

export default RegisteredTags;
